"use strict";
exports.__esModule = true;
exports.sortAndMap = void 0;
function sortAndMap(_a) {
    var array = _a.array, sortKey = _a.sortKey, mapCallback = _a.mapCallback;
    return array
        .sort(function (a, b) { return (a[sortKey] > b[sortKey] ? 1 : -1); })
        .map(mapCallback);
}
exports.sortAndMap = sortAndMap;
//# sourceMappingURL=SortAndMap.js.map